import { useInput, ValidationError } from "ra-core";
import { useFormContext, useWatch } from "react-hook-form";
import { MessageComposer } from "./MessageComposer";
import { validateNoteOrAttachmentRequired } from "./noteModel";
import type { AttachmentNote } from "../types";

export function NoteMessageInput({ placeholder }: { placeholder?: string }) {
  const { field, fieldState, id } = useInput({
    source: "text",
    validate: validateNoteOrAttachmentRequired,
  });
  const { control, setValue, formState, trigger } = useFormContext();
  const files = useWatch({ control, name: "attachments" }) as
    | AttachmentNote[]
    | null
    | undefined;
  return (
    <>
      <MessageComposer
        inputRef={field.ref}
        id={id}
        value={field.value || ""}
        onChange={field.onChange}
        onBlur={field.onBlur}
        files={files || []}
        onFilesChange={(items) => {
          setValue("attachments", items, {
            shouldDirty: true,
            shouldValidate: true,
          });
          void trigger("text");
        }}
        placeholder={placeholder}
        disabled={formState.isSubmitting}
      />
      {fieldState.error && (
        <p role="alert" className="text-sm text-destructive">
          <ValidationError error={fieldState.error.message || ""} />
        </p>
      )}
    </>
  );
}
